// extracted by mini-css-extract-plugin
export default {"modal":"DeleteJobsModal-module__modal__7J3aE","detail":"DeleteJobsModal-module__detail__QxYjl"};